import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './Nav.css'
import { FiSearch } from 'react-icons/fi'
import { FaBars, FaTimes } from "react-icons/fa";
import { auth } from '../../firebase';
import MarqueeBanner from '../MarqueeBanner/MarqueeBanner';
import { MOBILE_NAV_LINKS } from './mobileNavLinks';

function NavForNotHome() {
    const [searchtext, setsearchtext] = useState("false");
    const navigate = useNavigate()
    const navRef = useRef();

    const showNavbar = () => {
        navRef.current.classList.toggle("responsive_nav")
    };

    const goAndClose = (path) => {
        if (path.startsWith('mailto:')) return;
        navigate(path);
        showNavbar();
    };

    const isLoggedIn = auth.currentUser != null && auth.currentUser !== undefined;

    const leftLinks = (
        <>
            {isLoggedIn ? (
                <>
                    <p onClick={() => navigate("/alternativehomepage")} className="navbtns">Feed</p>
                    <p onClick={() => navigate("/app")} className="navbtns">App</p>
                </>
            ) : null}
            <p onClick={() => navigate("/createpremiummessage")} className="navbtns">Sell</p>
            <p onClick={() => navigate("/postonpremsi")} className="navbtns">Post</p>
            <p onClick={() => navigate("/invitation")} className="navbtns">For Creators</p>
            <form onSubmit={(e) => (e.preventDefault(), navigate("/search?q=" + searchtext))} className="searchform">
                <input onChange={(e) => setsearchtext(e.target.value)} className="searchinput" type="search" placeholder="Search Users/Groups/Premium Messages" />
                <FiSearch onClick={(e) => (e.preventDefault(), navigate("/search?q=" + searchtext))} className="searchicon" size={22} color="black" alt="Search" />
            </form>
        </>
    );

    const rightContent = !isLoggedIn
        ? <button type="button" className="nav-header__cta" onClick={() => navigate("/alternativehomepage")}>Sign In</button>
        : <button type="button" className="nav-header__cta" onClick={() => navigate("/profile")}>Account</button>;

    const mobileLinks = (isLoggedIn
        ? [{ label: 'feed', path: '/alternativehomepage' }, { label: 'app', path: '/app' }, ...MOBILE_NAV_LINKS]
        : MOBILE_NAV_LINKS
    );

    const goBrandHome = () => navigate(isLoggedIn ? "/alternativehomepage" : "/");

    return (
        <>
            <header className="nav-header">
                <div className="nav-header__sticky">
                    <div className="nav-header__left">
                        {leftLinks}
                    </div>
                    <div className="nav-header__brand-mobile" onClick={goBrandHome} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && goBrandHome()}>
                        PREMSI
                    </div>
                    <div className="nav-header__right">
                        {rightContent}
                    </div>
                    <button type="button" className="nav-btn" onClick={showNavbar} aria-label="Open menu">
                        <FaBars />
                    </button>

                    <nav ref={navRef} className="nav-header__mobile-nav">
                        <div className="mobile-nav__top">
                            <span className="mobile-nav__brand" onClick={() => { goBrandHome(); showNavbar(); }} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && (goBrandHome(), showNavbar())}>PREMSI</span>
                            <button type="button" className="mobile-nav__close" onClick={showNavbar} aria-label="Close menu">
                                <FaTimes />
                            </button>
                        </div>
                        <div className="mobile-nav__links">
                            {mobileLinks.map((item) => (
                                item.isMailto ? (
                                    <a key={item.label} href={item.path} className="mobile-nav__link"> {item.label} →</a>
                                ) : (
                                    <button key={item.label} type="button" className="mobile-nav__link" onClick={() => goAndClose(item.path)}> {item.label} →</button>
                                )
                            ))}
                        </div>
                        <div className="mobile-nav__cta-wrap">
                            {!isLoggedIn ? (
                                <button type="button" className="mobile-nav__cta" onClick={() => { navigate("/alternativehomepage"); showNavbar(); }}>Get started</button>
                            ) : (
                                <button type="button" className="mobile-nav__cta" onClick={() => { navigate("/profile"); showNavbar(); }}>Account</button>
                            )}
                        </div>
                        <div className="mobile-nav__socials">
                            <a href="https://www.instagram.com/premsicom" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <img loading="lazy" alt="" width={24} height={24} src={require('../../images/socialicons/instalogo.webp')} />
                            </a>
                            <a href="https://www.twitter.com/PremsiCom" target="_blank" rel="noopener noreferrer" aria-label="X">
                                <img loading="lazy" alt="" width={24} height={24} src={require('../../images/socialicons/twitter.webp')} />
                            </a>
                        </div>
                        <div className="mobile-nav__stores">
                            <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" target="_blank" rel="noopener noreferrer" className="mobile-nav__store-link mobile-nav__store-link--play">
                                <img loading="lazy" src={require('../../images/googleplay.webp')} alt="GET IT ON Google Play" height={40} />
                            </a>
                            <a href="https://apps.apple.com/app/apple-store/id6446628909" target="_blank" rel="noopener noreferrer" className="mobile-nav__store-link">
                                <img loading="lazy" src={require('../../images/appstore.webp')} alt="Download on the App Store" height={40} />
                            </a>
                        </div>
                    </nav>
                </div>
                <div className="nav-header__brand-wrap">
                    <div className="nav-header__brand" onClick={goBrandHome} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && goBrandHome()}>
                        PREMSI
                    </div>
                </div>
            </header>
            <MarqueeBanner />
        </>
    )
}

export default NavForNotHome
